module.exports = __webpack_public_path__ + "img/magic-wand.4cfdfc48.svg";